import { render, staticRenderFns } from "./SGPMainTabComponent.vue?vue&type=template&id=ba00f0e6"
import script from "./SGPMainTabComponent.vue?vue&type=script&lang=js"
export * from "./SGPMainTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports